"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get FILE_PART_SIZE () {
        return FILE_PART_SIZE;
    },
    get getReadStreamAsBase64 () {
        return getReadStreamAsBase64;
    },
    get getReadStreamAsUTF8 () {
        return getReadStreamAsUTF8;
    },
    get splitFileIntoParts () {
        return splitFileIntoParts;
    }
});
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
const getReadStream = ({ stream, encoding })=>_async_to_generator(function*() {
        const chunks = [];
        return new Promise((resolve, reject)=>{
            stream.on("data", (chunk)=>chunks.push(Buffer.from(chunk)));
            stream.on("error", (err)=>reject(err));
            stream.on("end", ()=>resolve(Buffer.concat(chunks).toString(encoding)));
        });
    })();
const getReadStreamAsBase64 = (stream)=>_async_to_generator(function*() {
        return getReadStream({
            stream,
            encoding: "base64"
        });
    })();
const getReadStreamAsUTF8 = (stream)=>_async_to_generator(function*() {
        return getReadStream({
            stream,
            encoding: "utf8"
        });
    })();
const FILE_PART_SIZE = 1024 * 1024 * 100; // 100MB
const splitFileIntoParts = ({ fileSize, partSize = FILE_PART_SIZE })=>{
    return {
        fileSize,
        partSize,
        numParts: Math.ceil(fileSize / partSize)
    };
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3V0aWxzL2ZpbGVzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFJlYWRhYmxlIH0gZnJvbSBcInN0cmVhbVwiO1xuXG5jb25zdCBnZXRSZWFkU3RyZWFtID0gYXN5bmMgKHtcbiAgc3RyZWFtLFxuICBlbmNvZGluZyxcbn06IHtcbiAgc3RyZWFtOiBSZWFkYWJsZTtcbiAgZW5jb2Rpbmc6IEJ1ZmZlckVuY29kaW5nO1xufSk6IFByb21pc2U8c3RyaW5nPiA9PiB7XG4gIGNvbnN0IGNodW5rczogQnVmZmVyW10gPSBbXTtcbiAgcmV0dXJuIG5ldyBQcm9taXNlKChyZXNvbHZlLCByZWplY3QpID0+IHtcbiAgICBzdHJlYW0ub24oXCJkYXRhXCIsIGNodW5rID0+IGNodW5rcy5wdXNoKEJ1ZmZlci5mcm9tKGNodW5rKSkpO1xuICAgIHN0cmVhbS5vbihcImVycm9yXCIsIGVyciA9PiByZWplY3QoZXJyKSk7XG4gICAgc3RyZWFtLm9uKFwiZW5kXCIsICgpID0+IHJlc29sdmUoQnVmZmVyLmNvbmNhdChjaHVua3MpLnRvU3RyaW5nKGVuY29kaW5nKSkpO1xuICB9KTtcbn07XG5cbmV4cG9ydCBjb25zdCBnZXRSZWFkU3RyZWFtQXNCYXNlNjQgPSBhc3luYyAoXG4gIHN0cmVhbTogUmVhZGFibGUsXG4pOiBQcm9taXNlPHN0cmluZz4gPT4ge1xuICByZXR1cm4gZ2V0UmVhZFN0cmVhbSh7IHN0cmVhbSwgZW5jb2Rpbmc6IFwiYmFzZTY0XCIgfSk7XG59O1xuXG5leHBvcnQgY29uc3QgZ2V0UmVhZFN0cmVhbUFzVVRGOCA9IGFzeW5jIChcbiAgc3RyZWFtOiBSZWFkYWJsZSxcbik6IFByb21pc2U8c3RyaW5nPiA9PiB7XG4gIHJldHVybiBnZXRSZWFkU3RyZWFtKHsgc3RyZWFtLCBlbmNvZGluZzogXCJ1dGY4XCIgfSk7XG59O1xuXG5leHBvcnQgY29uc3QgRklMRV9QQVJUX1NJWkUgPSAxMDI0ICogMTAyNCAqIDEwMDsgLy8gMTAwTUJcblxuZXhwb3J0IGNvbnN0IHNwbGl0RmlsZUludG9QYXJ0cyA9ICh7XG4gIGZpbGVTaXplLFxuICBwYXJ0U2l6ZSA9IEZJTEVfUEFSVF9TSVpFLFxufToge1xuICBmaWxlU2l6ZTogbnVtYmVyO1xuICBwYXJ0U2l6ZT86IG51bWJlcjtcbn0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBmaWxlU2l6ZSxcbiAgICBwYXJ0U2l6ZSxcbiAgICBudW1QYXJ0czogTWF0aC5jZWlsKGZpbGVTaXplIC8gcGFydFNpemUpLFxuICB9O1xufTtcbiJdLCJuYW1lcyI6WyJGSUxFX1BBUlRfU0laRSIsImdldFJlYWRTdHJlYW1Bc0Jhc2U2NCIsImdldFJlYWRTdHJlYW1Bc1VURjgiLCJzcGxpdEZpbGVJbnRvUGFydHMiLCJnZXRSZWFkU3RyZWFtIiwic3RyZWFtIiwiZW5jb2RpbmciLCJjaHVua3MiLCJQcm9taXNlIiwicmVzb2x2ZSIsInJlamVjdCIsIm9uIiwiY2h1bmsiLCJwdXNoIiwiQnVmZmVyIiwiZnJvbSIsImVyciIsImNvbmNhdCIsInRvU3RyaW5nIiwiZmlsZVNpemUiLCJwYXJ0U2l6ZSIsIm51bVBhcnRzIiwiTWF0aCIsImNlaWwiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O1FBNkJhQTtlQUFBQTs7UUFaQUM7ZUFBQUE7O1FBTUFDO2VBQUFBOztRQVFBQztlQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUE3QmIsTUFBTUMsZ0JBQWdCLENBQU8sRUFDM0JDLE1BQU0sRUFDTkMsUUFBUSxFQUlUO1FBQ0MsTUFBTUMsU0FBbUIsRUFBRTtRQUMzQixPQUFPLElBQUlDLFFBQVEsQ0FBQ0MsU0FBU0M7WUFDM0JMLE9BQU9NLEVBQUUsQ0FBQyxRQUFRQyxDQUFBQSxRQUFTTCxPQUFPTSxJQUFJLENBQUNDLE9BQU9DLElBQUksQ0FBQ0g7WUFDbkRQLE9BQU9NLEVBQUUsQ0FBQyxTQUFTSyxDQUFBQSxNQUFPTixPQUFPTTtZQUNqQ1gsT0FBT00sRUFBRSxDQUFDLE9BQU8sSUFBTUYsUUFBUUssT0FBT0csTUFBTSxDQUFDVixRQUFRVyxRQUFRLENBQUNaO1FBQ2hFO0lBQ0Y7QUFFTyxNQUFNTCx3QkFBd0IsQ0FDbkNJO1FBRUEsT0FBT0QsY0FBYztZQUFFQztZQUFRQyxVQUFVO1FBQVM7SUFDcEQ7QUFFTyxNQUFNSixzQkFBc0IsQ0FDakNHO1FBRUEsT0FBT0QsY0FBYztZQUFFQztZQUFRQyxVQUFVO1FBQU87SUFDbEQ7QUFFTyxNQUFNTixpQkFBaUIsT0FBTyxPQUFPLEtBQUssUUFBUTtBQUVsRCxNQUFNRyxxQkFBcUIsQ0FBQyxFQUNqQ2dCLFFBQVEsRUFDUkMsV0FBV3BCLGNBQWMsRUFJMUI7SUFDQyxPQUFPO1FBQ0xtQjtRQUNBQztRQUNBQyxVQUFVQyxLQUFLQyxJQUFJLENBQUNKLFdBQVdDO0lBQ2pDO0FBQ0YifQ==